import {
	ChangeDetectionStrategy,
	Component,
	ContentChild,
	HostBinding,
	Inject,
	Input,
	OnDestroy,
	OnInit,
	Optional,
	TemplateRef,
	ViewEncapsulation,
} from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";
import { select, Store } from "@ngrx/store";
import { GtmEventAction } from "@obg/gtm.types/adaptive";
import { AuthenticationStatus, AuthSelector, CoreState } from "@obg/ngx.core";
import { coerceBoolean, TelemetryService } from "@obg/ngx.global.evo";
import { Subscription } from "rxjs";
import { filter, pairwise, tap } from "rxjs/operators";

import { NavbarOptions } from "../navbar/navbar.model";

@Component({
	selector: "obg-m-dialog-layout",
	templateUrl: "./dialog-layout.component.html",
	styleUrls: ["./dialog-layout.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DialogLayoutComponent implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-dialog-layout") dialogLayout = true;
	@HostBinding("class.obg-m-dialog-layout-page") pageLayout = true;
	@HostBinding("class.obg-m-dialog-layout-hide-footer") @Input() hideFooter = false;
	/**
	 * @deprecated dialogId is not needed anymore: OBGD-2473
	 */
	@Input() dialogId: string | undefined;
	@Input() titleText: string | undefined;
	@Input() descriptionText: string | undefined;

	@Input()
	@coerceBoolean()
	navbar = false;

	@Input() navbarOptions: NavbarOptions | undefined;

	@Input()
	@coerceBoolean()
	loading = false;

	@Input() loadingMessage = "";

	@Input()
	@coerceBoolean()
	hideClose = false;

	@Input()
	@coerceBoolean()
	preserveDialogOnLogout = false;

	@ContentChild("customFooterTemplate", { static: false })
	customFooterTemplate: TemplateRef<unknown> | undefined;

	private autoClose$$: Subscription | undefined;

	constructor(
		@Optional() @Inject(MatDialogRef) private dialogRef: MatDialogRef<any> | undefined,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		private store: Store<CoreState>,
		private telemetryService: TelemetryService
	) {}

	private get gtmIdentifier(): string | undefined {
		return this.data?.dialogLike?.gtmIdentifier;
	}

	ngOnInit() {
		this.pageLayout = !this.isDialog;

		this.autoClose$$ = this.store
			.pipe(
				filter(() => this.isDialog),
				select(AuthSelector.getAuthenticationStatus),
				pairwise(),
				filter(
					([prev, curr]) =>
						prev === AuthenticationStatus.Authenticated &&
						curr === AuthenticationStatus.NotAuthenticated &&
						!this.preserveDialogOnLogout
				),
				tap(() => this.close())
			)
			.subscribe();
	}

	ngOnDestroy() {
		if (this.autoClose$$) {
			this.autoClose$$.unsubscribe();
		}
	}

	close(): boolean {
		if (this.dialogRef) {
			this.dialogRef.close();
			return true;
		}

		return false;
	}

	onCloseIconClick() {
		if (this.gtmIdentifier) {
			this.telemetryService.track({
				event: GtmEventAction.ClosePopup,
				ItemClicked: this.gtmIdentifier,
			});
		}
		return this.close();
	}

	get isDialog(): boolean {
		return !!this.dialogRef;
	}
}
